// React
import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Rating from '@material-ui/lab/Rating';

import EvalButton from '../EvalButton';

//import '../../index.css';

export default function Tables(props) {
   const { selectedDocs } = props;

   return (
      <TableContainer component={Paper} className="mng-search-content">
         <Table aria-label="simple table">
            <colgroup>
               <col style={{ width: '40%' }} />
               <col style={{ width: '15%' }} />
               <col style={{ width: '15%' }} />
               <col style={{ width: '30%' }} />
            </colgroup>
            <TableHead>
               <TableRow>
                  <TableCell>Documento</TableCell>
                  <TableCell align="right">Self Evaluation</TableCell>
                  <TableCell align="right">Qualità documento</TableCell>
                  <TableCell align="right">Commenti</TableCell>
               </TableRow>
            </TableHead>
            <TableBody>
               {selectedDocs.map(row => (
                  <TableRow key={row.documentName}>
                     <TableCell component="th" scope="row">
                        {row.pwa_doc.name}
                     </TableCell>
                     <TableCell align="right">{<EvalButton value={row.score} />}</TableCell>
                     <TableCell align="right">
                        <Rating name="rating" value={row.rating} readOnly />
                     </TableCell>
                     <TableCell align="right">{row.comment}</TableCell>
                  </TableRow>
               ))}
            </TableBody>
         </Table>
      </TableContainer>
   );
}
